import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatTableModule } from '@angular/material/table';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { NgForm } from '@angular/forms';
// import { LayoutComponent } from '@app/layout/layout.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DocumentTypeOptions, InvoiceInterface } from '@app/interface/invoice';
import { InvoiceApi } from '@app/services/invoice-api';
import { CompanyApi } from '@app/services/company-api';
import { Router } from '@angular/router';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
import {
  PaginatedResponse,
  RecursiveInterface,
} from '@app/services/base-authenticated.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { BarPlotComponent } from '@app/bar-plot/bar-plot.component';
import { PieChartComponent } from '@app/pie-chart/pie-chart.component';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { NgIf } from '@angular/common';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ChangeDetectorRef } from '@angular/core';
import { FiscalEventApi } from '@app/services/fiscal-event-api.service';
import { FiscalEventInterface } from '@app/interface/fiscal-event';
import { LayoutService } from '@app/layout/layout.service';
import { OnInit, AfterViewInit } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Organizations } from '@app/interface/organizations';
import { OrganizationApi } from '@app/services/organization-api.service';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectChange } from '@angular/material/select';
import { MessageApiService } from '@app/services/message-api.service';
import { MessageInterface } from '@app/interface/messages';
import { LinePlotComponent } from '@app/line-plot/line-plot.component';
import { AssistanceTicketInterface } from '@app/interface/assistance-ticket';
import { AssistanceTicketApiService } from '@app/services/assistance-ticket-api.service';
// import { ThemeChoiceService } from '@app/services/theme-choice.service';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { CorrispettiviReceiptsApi } from '@app/services/corrispettivi-receipts-api.service';
import { CorrispettiviReceiptsInterface } from '@app/interface/corrispettivi-receipts';
import { AtecoCodeApiService } from '@app/services/ateco-code-api.service';
import { AtecoCodeInterface } from '@app/interface/ateco-code';
import { MatBottomSheet, MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { QuickInvoiceBottomSheetComponent } from '@app/quick-invoice-bottom-sheet/quick-invoice-bottom-sheet.component';
import { ToastService } from '@app/services/toast.service';
import { IncomeStatementApiService } from '@app/services/income-statement-api.service';

/**
 * @title Basic use of `<table mat-table>`
 */
@Component({
  selector: 'app-dashboard',
  styleUrl: './dashboard.scss',
  templateUrl: './dashboard.html',
  imports: [
    MatTableModule,
    // MatTableDataSource,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    // LayoutComponent,
    MatProgressBarModule,
    // MatPaginator,
    MatPaginatorModule,
    MatCardModule,
    BarPlotComponent,
    PieChartComponent,
    LinePlotComponent,
    MatMenuModule,
    MatIconModule,
    NgIf,
    CommonModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatOptionModule,
    MatBadgeModule,
    MatTooltipModule,
    ReactiveFormsModule,
    MatBottomSheetModule,
  ],
  providers: [InvoiceApi, CompanyApi],

  standalone: true,
})
export class Dashboard implements OnInit, AfterViewInit {
  private toast = inject(ToastService);
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  totalAmount: number = 0;
  totalPaidAmount: number = 0;
  totalcorrispettiviAmount: number = 0;
  totalCreditNotesAmount: number = 0;
  totalCreditNotesPaidAmount: number = 0;
  targetAmount: number = 85000; // target amount

  lastThreeInvoices: InvoiceInterface[] = [];
  private latestInvoices: InvoiceInterface[] = [];
  private latestCreditNotes: InvoiceInterface[] = [];

  organization_data: Organizations | null = null;
  atecoCodes: AtecoCodeInterface[] = [];
  messagesNumber: number = 0;
  tickets: AssistanceTicketInterface[] = [];
  ticketsNumber: number = 0;
  // null finche' la chiamata non risponde: evita di mostrare "È ancora presto!"
  // per un istante prima del numero vero.
  incomeStatementsNumber: number | null = null;

  // for fiscal events
  nextFiscalEvent: FiscalEventInterface[] = [];
  nextYearEvents: FiscalEventInterface[] = [];
  currentYear = new Date().getFullYear();
  nextYear = this.currentYear + 1;
  nextYearTotalAmountTasse: number = 0;
  nextYearTotalAmountContributi: number = 0;

  years: number[] = [];
  selectedYear: number = this.currentYear;

  isLoading: boolean = true; // true until all critical data is loaded
  private loadingCounter: number = 0;
  errorMessage: string | null = null;

  // Inovice simulator
  simulatorForm: FormGroup;
  // Variabili per i risultati da mostrare
  taxableAmount: number = 0;
  taxesAmount: number = 0;
  pensionAmount: number = 0;
  finalResult: number = 0;

  constructor(
    private invoiceService: InvoiceApi,
    // private companyService: CompanyApi,
    private fiscalEventService: FiscalEventApi,
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    public layoutService: LayoutService,
    // public themeService: ThemeChoiceService,
    public organizationService: OrganizationApi,
    private messageApiService: MessageApiService,
    private ticketApiService: AssistanceTicketApiService,
    private Corrispettiviservice: CorrispettiviReceiptsApi,
    private fb: FormBuilder,
    private atecoCodeService: AtecoCodeApiService,
    private bottomSheet: MatBottomSheet,
    private incomeStatementService: IncomeStatementApiService,
    private destroyRef: DestroyRef = inject(DestroyRef),
  ) {
    this.simulatorForm = this.fb.group({
      total: [0], // Valore 1: Totale Fattura
      coefficient: [78], // Valore 2: Coefficiente di redditività (%)
      taxRate: [5], // Valore 3: Aliquota Imposta (%)
      pensionRate: [26.07], // Valore 4: Aliquota Previdenziale (%)
      otherPerc: [0], // Valore 5: Eventuale altra percentuale richiesta
    });
  }

  /** Increment before each critical API call; decrement on complete/error.
   *  isLoading stays true until every tracked call has finished. */
  private startLoading(): void {
    this.loadingCounter++;
    this.isLoading = true;
  }

  private stopLoading(): void {
    this.loadingCounter = Math.max(0, this.loadingCounter - 1);
    if (this.loadingCounter === 0) {
      this.isLoading = false;
      this.cdr.detectChanges();
    }
  }

  dataSource = new MatTableDataSource<InvoiceInterface>([]); // now usng MatTableDataSource
  corrispettiviSource = new MatTableDataSource<CorrispettiviReceiptsInterface>(
    [],
  );

  ngOnInit() {
    this.generateYears();

    // organization_data must be available before computeTotalAmounts() runs
    this.getOrganization();

    // These calls do NOT depend on organization_data — safe to fire in parallel.
    this.loadMessagesCount();
    this.loadEvents();
    this.loadIncomeStatementsCount();

    // Refresh this dashboard's own (duplicated) unread badges when a push
    // arrives in foreground - see side-menu.component.ts and
    // authorized-layout.component.ts#showForegroundNotification for the
    // other half of this. Unlike side-menu, Dashboard is destroyed/recreated
    // on every navigation to/from this route, so this one is torn down via
    // takeUntilDestroyed to avoid piling up a subscriber per visit.
    this.layoutService.newNotification$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.loadMessagesCount();
      });

    this.simulatorForm.valueChanges.subscribe((values) => {
      this.calculateInSimulator(values);
    });

    this.cdr.detectChanges();
  }

  ngAfterViewInit(): void {
    // computeTotalAmounts() is intentionally NOT called here
    this.cdr.detectChanges();
  }

  generateYears(): void {
    const currentYear = new Date().getFullYear();
    const startYear = 2024; // You can change this start year
    const endYear = currentYear + 2; // You can change this end year

    for (let year = startYear; year <= endYear; year++) {
      this.years.push(year);
    }

    // Optionally set default selection
    this.selectedYear = currentYear;
  }

  onYearSelected(event: MatSelectChange): void {
    this.loadInvoices();
    this.loadCreditNotes();
  }

  // for simulator
  calculateInSimulator(v: any) {
    // 1. Base Imponibile
    this.taxableAmount = v.total * (v.coefficient / 100);

    // 2. Imposta Sostitutiva
    this.taxesAmount = this.taxableAmount * (v.taxRate / 100);

    // 3. (Pension Fund
    this.pensionAmount = this.taxableAmount * (v.pensionRate / 100);

    this.finalResult = this.finalResult =
      v.total - this.taxesAmount - this.pensionAmount;
  }

  private getTaxRate(type: 'STARTUP' | 'ALIQUOTA_15'): number {
    const mapping = {
      STARTUP: 5,
      ALIQUOTA_15: 15,
    };
    return mapping[type] || 15;
  }

  private getPensionRate(fundType: string): number {
    if (!fundType) return 0;

    // Convertiamo tutto in MAIUSCOLO per un confronto sicuro
    const type = fundType.toUpperCase();
    // console.log('type', type);

    if (type.includes('SEPARATA')) {
      return 26.07;
    }

    if (type.includes('ARTIGIANI')) {
      return 24.0;
    }

    if (type.includes('COMMERCIANTI')) {
      return 24.48;
    }

    if (type.includes('ALTRA') || type.includes('CASSA')) {
      return 4.0;
    }

    return 0;
  }

  private getCoefficientByAteco(division: string, atecoClass: string): number {
    console.log('divsion', division);

    // --- Priority table (legge forfettario 2024) ---
    const divisionCoefficients: Record<string, number> = {
      // Industrie alimentari e delle bevande
      '10': 40,
      '11': 40,
      // Costruzioni e attività immobiliari
      '41': 86,
      '42': 86,
      '43': 86,
      '68': 86,
      // Alloggio e ristorazione
      '55': 40,
      '56': 40,
      // Commercio all'ingrosso e al dettaglio (escl. 46/47 con sotto-logica)
      '45': 40,
    };

    if (division in divisionCoefficients) {
      return divisionCoefficients[division];
    }

    // --- Altre attività economiche ---
    if (['01', '02', '03', '05', '06', '07', '08', '09'].includes(division))
      return 67;

    if (
      [
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24',
        '25',
        '26',
        '27',
        '28',
        '29',
        '30',
        '31',
        '32',
        '33',
      ].includes(division)
    )
      return 67;

    if (
      [
        '35',
        '36',
        '37',
        '38',
        '39',
        '58',
        '59',
        '60',
        '61',
        '62',
        '63',
      ].includes(division)
    )
      return 67;

    if (
      [
        '64',
        '65',
        '66',
        '69',
        '70',
        '71',
        '72',
        '73',
        '74',
        '75',
        '85',
        '86',
        '87',
        '88',
      ].includes(division)
    )
      return 78;

    if (
      [
        '77',
        '78',
        '79',
        '80',
        '81',
        '82',
        '84',
        '90',
        '91',
        '92',
        '93',
      ].includes(division)
    )
      return 67;

    if (['94', '95', '96', '97', '98', '99'].includes(division)) return 67;

    // Commercio all'ingrosso (46) — dipende dalla classe
    if (division === '46') {
      const firstDigit = atecoClass.charAt(0);
      if (['2', '3', '4', '5', '6', '7', '8', '9'].includes(firstDigit))
        return 40;
      if (firstDigit === '1') return 62;
    }

    // Commercio al dettaglio (47) — dipende dalla classe
    if (division === '47') {
      if (
        ['1', '2', '3', '4', '5', '6', '7', '9'].includes(atecoClass.charAt(0))
      )
        return 40;
      if (atecoClass === '81') return 40;
      if (atecoClass === '82' || atecoClass === '89') return 54;
    }

    return 78; // default servizi
  }

  initSimulator() {
    if (!this.organization_data) return;

    const data = this.organization_data;
    // console.log('quali dati?', data);

    const primaryAteco = this.atecoCodes[0] ?? null;
    const division = primaryAteco?.ateco_division ?? '';
    const atecoClass = primaryAteco?.ateco_class ?? '';

    const initialValues = {
      total: 1000, // Valore di default per la simulazione
      coefficient: this.getCoefficientByAteco(division, atecoClass),
      taxRate: this.getTaxRate(data.type),
      pensionRate: this.getPensionRate(data.inps_fund_type),
      otherPerc: 0,
    };

    this.simulatorForm.patchValue(initialValues);

    // INPS 30% reduction (Artigiani/Commercianti)
    if (
      data.has_30_percent_inps_reduction &&
      (data.inps_fund_type === 'ARTIGIANI' ||
        data.inps_fund_type === 'COMMERCIANTI')
    ) {
      const reducedRate = initialValues.pensionRate * 0.7;
      this.simulatorForm.get('pensionRate')?.setValue(reducedRate.toFixed(2));
    }
  }

  /** Numero di documenti nella sezione Dichiarazione dei redditi (stessa
   *  chiamata della pagina dichiarazione-redditi). */
  loadIncomeStatementsCount(): void {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.incomeStatementService.getAllStatements(organization_id).subscribe({
      next: (response) => {
        this.incomeStatementsNumber = (response.results || []).length;
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Error loading income statements:', error);
        this.incomeStatementsNumber = 0;
        this.cdr.detectChanges();
      },
    });
  }

  loadMessagesCount(): void {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    // Prepare filter params
    const filterParams: any = {};
    filterParams.is_read = false;

    this.messageApiService
      .getAllMessages<MessageInterface>(organization_id || 0, filterParams)
      .subscribe({
        next: (response) => {
          this.messagesNumber = response.results.length;
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error loading messages:', error);
          this.cdr.detectChanges();
        },
      });

    // filter for IN tickets
    filterParams.is_read = false;
    filterParams.type = 'IN';

    this.ticketApiService
      .getAllTickets<AssistanceTicketInterface>(
        organization_id || 0,
        filterParams,
      )
      .subscribe({
        next: (response2) => {
          // Filter and map messages
          this.tickets = response2.results;
          this.ticketsNumber = response2.results.length;
          // console.log('Numero tickets', this.ticketsNumber);

          // this.isLoading = false;

          this.cdr.detectChanges(); // Force change detection after data
        },
        error: (error) => {
          // this.isLoading = false;
          console.error('Error loading tickets:', error);

          this.cdr.detectChanges(); // Force change detection after data
        },
      });
  }

  // private performInitializationTask(): void {
  //   console.log('Performing initialization task...');
  //   this.isLoading = false;
  // }

  // private loadInvoices() {
  //   this.invoiceService.getInvoiceList({}).subscribe({
  //     next: (response: PaginatedResponse<InvoiceInterface>) => {
  //       this.dataSource.data = response.results;
  //       this.dataSource.paginator = this.paginator;

  //       // Calculate total paid amount for paid invoices
  //       this.totalAmount = response.results
  //         // .filter((invoice) => invoice.is_paid)
  //         .reduce((sum, invoice) => sum + Number(invoice.amount), 0); // Convert to Number

  //       // Calculate total paid amount for paid invoices
  //       this.totalPaidAmount = response.results
  //         .filter((invoice) => invoice.is_paid)
  //         .reduce((sum, invoice) => sum + Number(invoice.amount), 0); // Convert to Number

  //       // round
  //       this.totalAmount = this.roundToTwo(this.totalAmount);
  //       this.totalPaidAmount = this.roundToTwo(this.totalPaidAmount);
  //       console.log('Total paid amount:', this.totalPaidAmount);

  //       // Get last 3 invoices by emission date
  //       this.lastThreeInvoices = [...response.results]
  //         .sort(
  //           (a, b) =>
  //             new Date(b.emission_date).getTime() -
  //             new Date(a.emission_date).getTime()
  //         )
  //         .slice(0, 3);

  //       this.cdr.detectChanges();
  //     },
  //     error: (err: any) => {
  //       console.error('Error loading invoices:', err);
  //       this.showErrorMessage('Failed to load invoices');
  //     },
  //   });
  // }

  private getOrganization() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.startLoading();

    const filterParams = {
      organization_id: organization_id,
    };

    this.organizationService
      .getOrganization<Organizations>(organization_id, filterParams)
      .subscribe({
        next: (organization_data: Organizations) => {
          this.organization_data = organization_data;

          // Now that organization_data (including favorite_pension_fund) is set,
          // load financial data so computeTotalAmounts() sees the correct TC22 flag.
          this.loadInvoices();
          this.loadCorrispettivi();
          this.loadCreditNotes();

          // Load ATECO codes then initialize simulator with real division/class
          this.atecoCodeService
            .getAllAtecoCodes<AtecoCodeInterface>(organization_id, {})
            .subscribe({
              next: (response: RecursiveInterface<AtecoCodeInterface>) => {
                this.atecoCodes = response.results;
                if (response.completed) {
                  this.initSimulator();
                }
              },
              error: () => {
                // Fallback: init simulator without ATECO data
                this.initSimulator();
              },
            });

          this.stopLoading();
          this.cdr.detectChanges();
        },
        error: (err: any) => {
          console.error('Error loading organization:', err);
          this.showErrorMessage('Errore durante il caricamento.');
          this.stopLoading();
          this.cdr.detectChanges();
        },
      });
  }

  // no more useful
  // applyOrganizationTheme(source: string): void {
  //   // Step 5: Map the source to a theme
  //   // Your Django source can be: 'IZY', 'UIL', or 'OTHER'
  //   if (source === 'IZY' || source === 'UIL' || source === 'OTHER') {
  //     this.themeService.applyTheme(source);
  //   } else {
  //     // If source is something else, default to IZY
  //     this.themeService.applyTheme('IZY');
  //   }
  // }

  private loadInvoices() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.startLoading();
    this.errorMessage = null;

    const filterParams = {
      is_draft: false,
      is_deleted: false,
      is_preventive: false,
      is_saved_for_preview: false,
      status__not: 'SCARTATA',
      document_type: 'TD01',
      emission_date__year: this.selectedYear,
    };

    this.invoiceService
      .getAllInvoices<InvoiceInterface>(organization_id, filterParams)
      .subscribe({
        next: (response: RecursiveInterface<InvoiceInterface>) => {
          if (response.completed) {
            const allInvoices = response.results;

            this.dataSource.data = allInvoices;
            this.dataSource.paginator = this.paginator;

            this.computeTotalAmounts();

            this.latestInvoices = allInvoices;
            this.updateLastThreeDocuments();

            this.stopLoading();
            this.cdr.detectChanges();
          } else {
            console.log(`Loaded ${response.results.length} invoices so far...`);
          }
        },
        error: (err: any) => {
          console.error('Error loading invoices:', err);
          this.showErrorMessage('Errore durante il caricamento delle fatture.');
          this.stopLoading();
          this.cdr.detectChanges();
        },
      });
  }

  loadCorrispettivi() {
    this.startLoading();
    const orgId = Number(this.route.snapshot.paramMap.get('organizationId'));

    const params = {
      organization_id: orgId,
      transmission_date__year: this.selectedYear,
      is_deleted: false,
    };

    this.Corrispettiviservice.getAllCorrispettiviReceipts(
      orgId,
      params,
    ).subscribe({
      next: (response: any) => {
        this.corrispettiviSource.data = response.results || [];
        this.computeTotalAmounts();
        this.stopLoading();
      },
      error: () => this.stopLoading(),
    });
  }

  computeTotalAmounts() {
    const allInvoices = this.dataSource.data;
    const allCorrispettivi = this.corrispettiviSource.data;

    // Calculate total amount (all invoices) if INPS
    if (this.organization_data?.favorite_pension_fund === 'TC22') {
      this.totalAmount = allInvoices.reduce(
        // (sum, invoice) => sum + Number(invoice.amount || 0),
        (sum, invoice) => sum + Number(invoice.amount || 0), // - invoice.discount_amount
        0,
      );
    } else {
      this.totalAmount = allInvoices.reduce(
        // (sum, invoice) => sum + Number(invoice.amount || 0),
        (sum, invoice) =>
          sum +
          Number(invoice.amount - invoice.revenge - invoice.pension_fund || 0), // - invoice.discount_amount
        0,
      );
    }

    // Calculate total paid amount (only paid invoices) if INPS
    if (this.organization_data?.favorite_pension_fund === 'TC22') {
      this.totalPaidAmount = allInvoices
        .filter((invoice) => invoice.is_paid)
        .reduce(
          (sum, invoice) => sum + Number(invoice.amount || 0), //  - invoice.discount_amount
          0,
        ); // without withholdings
    } else {
      this.totalPaidAmount = allInvoices
        .filter((invoice) => invoice.is_paid)
        .reduce(
          (sum, invoice) =>
            sum +
            Number(
              invoice.amount - invoice.revenge - invoice.pension_fund || 0,
            ), //  - invoice.discount_amount
          0,
        ); // without withholdings
    }

    this.totalcorrispettiviAmount = allCorrispettivi
      // .filter((corrispettivo) => corrispettivo.is_paid)
      .reduce(
        (sum, corrispettivo) => sum + Number(corrispettivo.amount || 0),
        0,
      );

    // summing up invoices and corrispettivi
    this.totalAmount += this.totalcorrispettiviAmount;
    this.totalPaidAmount += this.totalcorrispettiviAmount; // Corrispettivi are always paid

    // Round values
    this.totalAmount = this.roundToTwo(this.totalAmount);
    this.totalPaidAmount = this.roundToTwo(this.totalPaidAmount);

    console.log(
      'All invoices loaded. Total:',
      this.totalAmount,
      'Paid:',
      this.totalPaidAmount,
    );

    this.cdr.detectChanges();
  }

  // merges invoices (TD01) and credit notes (TD04) into the "Ultimi documenti emessi" list
  private updateLastThreeDocuments() {
    this.lastThreeInvoices = [...this.latestInvoices, ...this.latestCreditNotes]
      // Ordina per data di emissione (più recente prima). Fatture e note di
      // credito hanno sequenze di id indipendenti, quindi ordinare per id
      // mescolerebbe le due recency; a parità/assenza di data si usa l'id.
      .sort((a, b) => {
        const da = a.emission_date ? new Date(a.emission_date).getTime() : 0;
        const db = b.emission_date ? new Date(b.emission_date).getTime() : 0;
        return db - da || +b.id - +a.id;
      })
      .slice(0, 3);
  }

  private loadCreditNotes() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.startLoading();
    this.errorMessage = null;

    const filterParams = {
      is_draft: false,
      is_deleted: false,
      is_preventive: false,
      document_type: 'TD04',
      emission_date__year: this.selectedYear,
    };

    this.invoiceService
      .getAllInvoices<InvoiceInterface>(organization_id, filterParams)
      .subscribe({
        next: (response: RecursiveInterface<InvoiceInterface>) => {
          if (response.completed) {
            const allInvoices = response.results;

            this.totalCreditNotesAmount = this.roundToTwo(
              allInvoices.reduce(
                (sum, invoice) =>
                  sum +
                  Number(invoice.gross_amount - invoice.discount_amount || 0),
                0,
              ),
            );

            this.totalCreditNotesPaidAmount = this.roundToTwo(
              allInvoices
                .filter((invoice) => invoice.is_paid)
                .reduce(
                  (sum, invoice) =>
                    sum +
                    Number(invoice.gross_amount - invoice.discount_amount || 0),
                  0,
                ),
            );

            this.latestCreditNotes = allInvoices;
            this.updateLastThreeDocuments();

            console.log(
              'All credit notes loaded. Total:',
              this.totalCreditNotesAmount,
              'Paid:',
              this.totalCreditNotesPaidAmount,
            );

            this.stopLoading();
            this.cdr.detectChanges();
          } else {
            console.log(
              `Loaded ${response.results.length} credit notes so far...`,
            );
          }
        },
        error: (err: any) => {
          console.error('Error loading credit notes:', err);
          this.showErrorMessage('Errore durante il caricamento delle fatture.');
          this.stopLoading();
          this.cdr.detectChanges();
        },
      });
  }

  private loadEvents() {
    const organization_id = this.route.snapshot.paramMap.get('organizationId');

    // Handle the case where organization_id might be null
    if (!organization_id) {
      console.error('Organization ID not found in route');
      return;
    }

    this.fiscalEventService.getEventList(organization_id, {}).subscribe({
      next: (response: PaginatedResponse<FiscalEventInterface>) => {
        // Get next 3 events by date (only TASSE events now)
        this.nextFiscalEvent = [...response.results]
          .sort(
            (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
          )
          .slice(0, 1);
      },
      error: (err: any) => {
        console.error('Error loading TASSE events:', err);
        this.showErrorMessage(
          'Errore durante il caricamento del piano fiscale.',
        );
      },
    });

    // Use the filter to only get events with type exactly "TASSE"
    const filterParams1 = {
      type: 'TASSE', // This will use the exact filter from your Django backend
    };

    this.fiscalEventService
      .getEventList(organization_id, filterParams1)
      .subscribe({
        next: (response: PaginatedResponse<FiscalEventInterface>) => {
          // Your existing logic
          this.nextYearEvents = [...response.results].filter((event) => {
            const eventYear = new Date(event.date).getFullYear();
            return eventYear === this.nextYear;
          });

          this.nextYearTotalAmountTasse =
            this.calculateTotalAmountForNextYear();

          // console.log('TASSE events for next year:', this.nextYearEvents);
          // console.log(
          //   'Next year TASSE total amount:',
          //   this.nextYearTotalAmountTasse,
          // );
          this.cdr.detectChanges();
        },
        error: (err: any) => {
          console.error('Error loading TASSE events:', err);
          this.showErrorMessage(
            'Errore durante il caricamento del piano fiscale.',
          );
        },
      });

    // filter to only get events with type exactly "CONTRIBUTI"
    const filterParams2 = {
      type: 'CONTRIBUTI', // filter from Django backend
    };

    this.fiscalEventService
      .getEventList(organization_id, filterParams2)
      .subscribe({
        next: (response: PaginatedResponse<FiscalEventInterface>) => {
          // Get next year TASSE events by date
          this.nextYearEvents = [...response.results].filter((event) => {
            const eventYear = new Date(event.date).getFullYear();
            return eventYear === this.nextYear;
          });

          // Calculate total amount for TASSE events only
          this.nextYearTotalAmountContributi =
            this.calculateTotalAmountForNextYear();

          // console.log('CONTRIBUTI events for next year:', this.nextYearEvents);
          // console.log(
          //   'Next year CONTRIBUTI total amount:',
          //   this.nextYearTotalAmountContributi,
          // );
          this.cdr.detectChanges();
        },
        error: (err: any) => {
          console.error('Error loading CONTRIBUTI events:', err);
          this.showErrorMessage(
            'Errore durante il caricamento del piano fiscale.',
          );
        },
      });
  }

  formatAmount(amount: number): string {
    return new Intl.NumberFormat('it-IT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }

  private calculateTotalAmountForNextYear(): number {
    if (!this.nextYearEvents || this.nextYearEvents.length === 0) {
      return 0;
    }

    return this.nextYearEvents.reduce((total, event) => {
      // Handle cases where amount might be undefined or null
      const amount = Number(event.amount) || 0;
      return total + amount;
    }, 0);
  }

  // Helper function for proper rounding
  private roundToTwo(num: number): number {
    return Math.round((num + Number.EPSILON) * 100) / 100;
  }

  // Calculate progress percentage
  getProgressValue(): number {
    return this.roundToTwo(
      ((this.totalAmount - this.totalCreditNotesAmount) / this.targetAmount) *
        100,
    );
  }

  navigateToInvoices() {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    // console.log(org_id);
    if (this.organization_data?.has_also_corrispettivi_receipts === true) {
      this.router.navigate([`/${org_id}/corrispettivi-receipts`]);
    } else {
      this.router.navigate([`/${org_id}/invoices_table`]);
    }
  }

  onRowClick(invoice: InvoiceInterface) {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/invoice`, invoice.id]);
  }

  navigateToNewInvoice(documentType?: DocumentTypeOptions) {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    // console.log(org_id);
    this.router.navigate([`/${org_id}/new_invoice`]);
  }

  openQuickInvoice(): void {
    if (!this.organization_data) return;

    const ref = this.bottomSheet.open(QuickInvoiceBottomSheetComponent, {
      data: {
        organizationId: Number(this.route.snapshot.paramMap.get('organizationId')),
        organization: this.organization_data,
      },
      panelClass: 'quick-invoice-bottom-sheet',
    });

    ref.afterDismissed().subscribe((result) => {
      if (result?.reload) {
        this.loadInvoices();
      }
    });
  }

  navigateToCreditNote() {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/new_invoice`], {
      queryParams: {
        documentType: 'TD04',
      },
    });
  }

  navigateToNewCompany() {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    // console.log(org_id);
    this.router.navigate([`/${org_id}/new_company`]);
  }

  navigateToNewPreventive() {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    // console.log(org_id);
    this.router.navigate([`/${org_id}/new_preventive`]);
  }

  navigateToNewSavedProduct() {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    // console.log(org_id);
    this.router.navigate([`/${org_id}/new_savedproduct`]);
  }

  navigateToDichiarazione() {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    // console.log(org_id);
    this.router.navigate([`/${org_id}/dichiarazione`]);
  }

  navigateToPreventives() {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    // console.log(org_id);
    this.router.navigate([`/${org_id}/preventives_table`]);
  }

  navigateToMessages() {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    // console.log(org_id);
    this.router.navigate([`/${org_id}/inbox`]);
  }

  navigateToChat() {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    // console.log(org_id);
    this.router.navigate([`/${org_id}/commercialista-tickets`]);
  }

  // Mirrors the guard already used for the chat badge/button elsewhere in
  // this template: chat is only available for BEIZY orgs that aren't
  // invoicing-only. loadMessagesCount() fetches ticketsNumber unconditionally,
  // so without this an org without chat could still count/show it here.
  get canUseChat(): boolean {
    return !!(
      this.organization_data &&
      this.organization_data.is_only_invoicing === false &&
      this.organization_data.source === 'BEIZY'
    );
  }

  // Backs the unread-notifications summary card shown below the header
  // card when there's at least one unread message and/or ticket reply.
  get unreadNotificationsCount(): number {
    const tickets = this.canUseChat ? this.ticketsNumber || 0 : 0;
    return (this.messagesNumber || 0) + tickets;
  }

  get unreadNotificationsLabel(): string {
    const count = this.unreadNotificationsCount;
    return count === 1
      ? `C'è ${count} nuova notifica da leggere.`
      : `Ci sono ${count} nuove notifiche da leggere.`;
  }

  navigateToTutorials() {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    // console.log(org_id);
    this.router.navigate([`/${org_id}/guides`]);
  }

  navigateToFiscalPlan() {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    // console.log(org_id);
    this.router.navigate([`/${org_id}/fiscal_plan`]);
  }

  private showSuccessMessage(message: string): void {
    this.toast.success(message);
  }

  private showErrorMessage(message: string): void {
    this.toast.error(message);
  }
}
